var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.255.064a.5.5 0 01.49 0l4 2.25A.5.5 0 019 2.75v4.5a.5.5 0 01-.255.436l-4 2.25a.5.5 0 01-.49 0l-4-2.25A.5.5 0 010 7.25v-4.5a.5.5 0 01.255-.436l4-2.25zM1 3.604l3 1.688v3.353L1 6.958V3.605zm4 5.041l3-1.687V3.605L5 5.292v3.353zm-.5-4.219L7.48 2.75l-1.044-.587L3.565 3.9l.935.526zM2.564 3.337L5.435 1.6 4.5 1.074 1.52 2.75l1.044.587z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--package-83fa3d37d34958b1f7dda0b22a1c3a21.svg";
export { SvgIconUiPackage as Component };